import React, { useEffect, useState } from 'react'
import { Col, Row, Skeleton } from 'antd'
import { openNotificationWithIcon } from '../../../../../utils/helper'
import { getAIs, updateAI } from '../../../../../api/ai/aitutor'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../../store/store'
import { updateUser } from '../../../../../store/userSlice/userSlice'
import {
	LoadingOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom'
import Ais from './ais/ais'

// const percentage = 80

const Studenttutor = () => {
	const dispatch = useDispatch()
	const navigate = useNavigate()

	const [currentItem, setCurrentItem] = useState<any>(null)
	const [loading, setLoading] = useState(true)
	const [ais, setAis] = useState([])
	const [updating, setUpdating] = useState(false)

	const state = useSelector((state: RootState) => ({
		user: state.user.user,
	}))

	const { user } = state

	const tutorClick = (item: any) => {
		setCurrentItem(item)
	}

	const fetchAis = async () => {
		try {
			setLoading(true)
			const res = await getAIs()
			const { data } = res.data
			setAis(data.ais)
			const currentTutor = data.ais.filter((item: any) => item._id === user?.aiTutor)
			setCurrentItem(currentTutor.length > 0 ? currentTutor[0] : data.ais[0])
			setLoading(false)

		} catch (error: any) {
			setLoading(false)
			if (error?.response) {
				openNotificationWithIcon('error', 'Get AIs', `${error?.response?.data?.message || 'Something went wrong'}`)
			} else {
				openNotificationWithIcon('error', 'Get AIs', 'Something went wrong')
			}
		}
	}

	const effectUpdateUpdateAI = async () => {
		try {
			setUpdating(true)

			const res = await updateAI(user?.aiTutorAssignmentId, {
				aiId: currentItem?._id
			})

			dispatch(updateUser({
				user: {
					...user,
					aiTutor: currentItem?._id
				}
			}))

			const { message } = res.data

			openNotificationWithIcon("success", "Update AI Tutor", message)

			setUpdating(false)

			dispatch(updateUser({
				user: {
					...user,
					aiTutorDetails: currentItem
				}
			}))

		} catch (error: any) {
			setUpdating(false)
			if (error?.response) {
				openNotificationWithIcon('error', 'Update AI Tutor', `${error?.response?.data?.message || 'Something went wrong'}`)
			} else {
				openNotificationWithIcon('error', 'Update AI Tutor', 'Something went wrong')
			}
		}
	}

	useEffect(() => {
		fetchAis()

		// eslint-disable-next-line
	}, [])

	return (
		<div className='h-screen'>
			<Row gutter={16}>
				<Col xs={24} md={24} lg={14}>
					{
						loading ?
							<div>
								<Skeleton.Button active={true} size={'large'} shape={'square'} block={true}
									style={{
										height: '40rem',
										marginBottom: '0.3rem',
										borderRadius: '1rem',
										marginRight: '1rem'
									}}
								/>
							</div>
							:
							<div className='flex flex-col border rounded-[30px] custom-primary-bg-three p-4'>
								<p className='font-semibold text-[22px] leading-[107%] text-appcolorwhite'>
									{
										currentItem?.name
									}
								</p>

								<div className='py-[5rem] flex justify-center'>
									{/* <img src={currentItem?.frontView} alt="jide"
										className='w-[44rem]'
									/> */}
									<video
										src={currentItem?.headShotVideo}
										autoPlay
										loop
										style={{
											backgroundColor: 'transparent',
											width: ' 100%',
											height: 'auto'
										}}
									/>
								</div>
							</div>
					}



					<div className='mt-4'>
						<p className='text-appcolorblack opacity-[0.6] mb-4 text-base font-bold'>
							Story
						</p>

						{
							loading ?
								<div>
									<Skeleton.Button active={true} size={'large'} shape={'square'} block={true}
										style={{
											height: '5rem',
											marginBottom: '0.3rem',
											borderRadius: '1rem',
											marginRight: '1rem'
										}}
									/>
								</div>
								:
								<>
									<p className='text-base'>
										{
											currentItem?.description
										}
									</p>


									<div className='flex items-center mt-4'>
										<p className='w-fit px-4 py-[0.5rem] mr-4 text-appcolorpurple text-base cursor-pointer'
											onClick={() => {
												navigate('/student/dashboard')
											}}
										>
											Cancel
										</p>

										<p className='w-fit px-4 py-[0.5rem] text-appcolorpurple text-base cursor-pointer bg-appcolorblackfainteight rounded-[40px] flex items-center'
											onClick={() => {
												if (!updating) {
													effectUpdateUpdateAI()
												}
											}}
										>
											{
												updating ?
													<LoadingOutlined
														className='mr-[0.5rem]'
													/> : null
											}

											<span>
												Select Character
											</span>
										</p>
									</div>
								</>
						}
					</div>


				</Col>
				<Col xs={24} md={24} lg={10}>
					<div className='pl-[2rem]'>
						<div className='flex'>
							<p className='text-appcolorblack opacity-[0.6] text-base font-bold'>
								Pick Your Tutor
							</p>
						</div>

						<div className={`grid grid-flow-col grid-rows-2 ${loading ? 'gap-6' : 'gap-1'} mt-8`}>
							{
								loading ?
									[1, 2, 3, 4, 5, 6].map((index) => (
										<div
											key={`tutor-loader-${index}-avatar`}
										>
											<Skeleton.Button active={true} size={'large'} shape={'square'} block={true}
												style={{
													height: '7rem',
													marginBottom: '0.3rem',
													borderRadius: '29px',
													marginRight: '1rem'
												}}
											/>
										</div>
									))
									:
									ais.map((item: any, index) => (
										<div className='mb-4'
											key={`tutor-${index}-avatar`}
										>
											<Ais
												img={item?.headShot}
												isBigger
												aiClick={tutorClick}
												aiDetails={{
													...item
												}}
												name={item.name}
												active={currentItem?._id === item?._id}
											/>
										</div>
									))
							}
						</div>

						{/* <div className='mt-[4rem]'>
							<div className='flex items-center mb-4'>
								<img src="/img/vectors/yellowprofile.svg" alt="yellowprofile" className='h-8' />
								<p className='text-appcolorblack opacity-[0.6] text-base font-bold'>
									Character Bonuses
								</p>
							</div>

							<div className='pl-8'>
								<p className='mb-2 text-base'>
									<b>-</b> <b>+30</b> seconds on RAM Runs
								</p>
								<p className='text-base'>
									<b>-</b> <b>+20%</b> chance of  NFT rewards
								</p>
							</div>
						</div> */}
					</div>
				</Col>
			</Row>
		</div >
	)
}

export default Studenttutor